import { useRequest } from 'ahooks';
import { getUplaodFile } from './api';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { ElDialog, ElScrollbar, ScrollbarRef } from '@qsxy/element-plus-react';
import { ModalPageRef } from '@/typings';
import { renderAsync } from 'docx-preview';
import LuckyExcel from 'luckyexcel';
import { init } from 'pptx-preview';

declare global {
	interface Window {
		luckysheet: any;
	}
}

const FilePreview = forwardRef<ModalPageRef<any>, any>((props, ref) => {
	const { runAsync } = useRequest(getUplaodFile, { manual: true });

	const [documnets, setDocuments] = useState<{
		fileType: string;
		url?: string;
	}>({
		fileType: 'word',
		url: '',
	});

	const [visible, setVisible] = useState(false);

	const contentRef = useRef<HTMLDivElement>(null);
	const scrollRef = useRef<ScrollbarRef>(null);

	const previewExcel = (blob: Blob) => {
		const reader = new FileReader();

		reader.onload = function () {
			const buffer = this.result;
			LuckyExcel.transformExcelToLucky(buffer, function (exportJson) {
				exportJson.sheets[0].zoomRatio = 1;
				if (window.luckysheet && window.luckysheet.create) {
					window.luckysheet?.create({
						container: 'excel', //luckysheet is the container id
						lang: 'zh',
						showtoolbar: false, //是否显示工具栏
						showinfobar: false, //是否显示顶部信息栏
						showsheetbar: true, //是否显示底部sheet页按钮
						allowCopy: false, //是否允许拷贝
						allowEdit: false, //是否允许编辑
						showstatisticBar: false, //是否显示底部计数栏
						sheetFormulaBar: false, //是否显示公示栏
						enableAddRow: false, //是否允许添加行
						enableAddBackTop: false, //是否允需回到顶部
						// devicePixelRatio: 10, //设置比例
						data: exportJson.sheets,
					});
				}
			});
		};
		reader.readAsArrayBuffer(blob);
	};

	const previewWord = (blob: Blob) => {
		const reader = new FileReader();

		reader.onload = function () {
			const buffer = this.result;
			renderAsync(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }), contentRef.current).then(() => {
				scrollRef.current.update();
			});
		};
		reader.readAsArrayBuffer(blob);
	};

	const previewPpt = (blob: Blob) => {
		const reader = new FileReader();

		reader.onload = function () {
			const buffer = this.result as ArrayBuffer;
			const pptxPrviewer = init(document.getElementById('pptx-wrapper'), {
				width: 1280,
				height: 800,
			});
			//调用预览器的preview方法
			pptxPrviewer.preview(buffer).then(() => {
				scrollRef.current.update();
			});
		};
		reader.readAsArrayBuffer(blob);
	};

	// const handlePreview = event => {
	// 	const fileObj = event.target.files[0];
	// 	if (fileObj.name.endsWith('docx')) {
	// 		setDocuments({ fileType: 'word' });
	// 		const fr = new FileReader();
	// 		fr.readAsArrayBuffer(fileObj);
	// 		fr.addEventListener(
	// 			'loadend',
	// 			e => {
	// 				const buffer = e.target.result;
	// 				renderAsync(new Blob([buffer], { type: fileObj.type }), contentRef.current).then(() => {
	// 					scrollRef.current.update();
	// 				});
	// 			},
	// 			false,
	// 		);
	// 	} else if (fileObj.name.endsWith('xlsx')) {
	// 		setDocuments({ fileType: 'excel' });
	// 		previewExcel(event);
	// 	} else if (fileObj.name.endsWith('pdf')) {
	// 		setDocuments({ fileType: 'pdf' });
	// 	} else if (fileObj.name.endsWith('pptx')) {
	// 		setDocuments({ fileType: 'ppt' });
	// 		previewPpt(event);
	// 	} else if (fileObj.name.endsWith('png') || fileObj.name.endsWith('jpg')) {
	// 		setDocuments({ fileType: 'image' });
	// 	}
	// };

	useImperativeHandle(ref, () => ({
		open: (data: { name: string; path: string }) => {
			let { name } = data;
			name = name.toLocaleLowerCase();
			runAsync(data).then(blob => {
				if (name.endsWith('docx')) {
					setDocuments({ fileType: 'word' });
					previewWord(blob);
				} else if (name.endsWith('xlsx')) {
					setDocuments({ fileType: 'excel' });
					previewExcel(blob);
				} else if (name.endsWith('pdf')) {
					const _url = window.URL.createObjectURL(
						new Blob([blob], {
							type: 'Application/pdf',
						}),
					);
					setDocuments({ fileType: 'pdf', url: _url });
				} else if (name.endsWith('pptx')) {
					setDocuments({ fileType: 'ppt' });
					previewPpt(blob);
				} else if (name.endsWith('png') || name.endsWith('jpg') || name.endsWith('jpeg') || name.endsWith('gif')) {
					setDocuments({ fileType: 'image', url: window.URL.createObjectURL(blob) });
				}
			});
			setVisible(true);
		},
	}));

	return (
		<ElDialog
			title="文件预览"
			width="90%"
			className="file-preview"
			visible={visible}
			top="5"
			// style={{ '--el-dialog-margin-top': '0px' }}
			close={() => {
				setDocuments({ fileType: '' });
				setVisible(false);
			}}
		>
			<ElDialog.body>
				<ElScrollbar ref={scrollRef} always>
					{/* <input type="file" onChange={handlePreview} /> */}
					{documnets.fileType === 'pdf' ? <iframe className="ttn-pdf-previewer" src={documnets.url}></iframe> : null}
					{documnets.fileType === 'image' ? (
						<div className="ttn-image-previewer">
							<img src={documnets.url}></img>
						</div>
					) : null}
					{documnets.fileType === 'excel' ? <div id="excel" className="ttn-pdf-previewer"></div> : null}
					{documnets.fileType === 'word' ? <div ref={contentRef} className="ttn-pdf-previewer"></div> : null}
					{documnets.fileType === 'ppt' ? <div id="pptx-wrapper" className="ttn-pdf-previewer"></div> : null}
				</ElScrollbar>
			</ElDialog.body>
		</ElDialog>
	);
});

export default FilePreview;
